// Freshness banding for the open-quote funnel.
//
// Age-band boundaries in working days. One source of truth: the bands bar, the
// win-curve overlay, and the /views/quote-funnel endpoint must agree on where
// "hot" stops, or the same quote reads two temperatures in two places.
// A working week is 5 days; three working weeks (~the point where the
// front-loaded curve has flattened to ~99% of plateau) is the cold line.
//
// Presentation-side domain logic, not a wire shape — the band totals
// themselves arrive from the backend as ``QuoteFunnelBands``.

import type { QuoteFunnelBands } from "../data/api-types";

export const HOT_MAX_WD = 5;
export const LUKEWARM_MAX_WD = 15;

/** Which band a quote of the given working-day age falls in. */
export function quoteTemperature(ageWd: number): keyof QuoteFunnelBands {
  if (ageWd <= HOT_MAX_WD) return "hot";
  if (ageWd <= LUKEWARM_MAX_WD) return "warm";
  return "cold";
}
